import _ from 'lodash';

import jwt from '../jwt';

const apiHelpers = {
  request(path, options) {
    return fetch(`${APP_CONFIG.api}/${path}`, options)
      .then(response => response.json())
      .then((result) => {
        if (result.status === 'success' && _.get(result, 'data')) return result.data;
        if (result && !result.data) throw new Error('API format has changed');

        throw _.first(result.errors);
      });
  },

  requestOptions(method, data) {
    const token = jwt.getAuthToken();

    return {
      method,
      body: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };
  },
};

export default apiHelpers;
